import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, AfterViewInit, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuestionnaireService } from '../services/questionnaire.service';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray, ValidatorFn, AbstractControl } from '@angular/forms';
import { IncomesArrayComponent } from '../incomes-array/incomes-array.component';
import { BorrowersArrayComponent } from '../borrowers-array/borrowers-array.component';
import { ValidateId } from '../id-validator';
import { ValidateDate } from '../date-validator';
import { Draft } from '../services/draft.service';
import { SystemTablesService } from "../services/system-tables.service";
import { ValidateNegativeNumber } from '../negative-number-validator';
import { SysTableObj } from '../models/sysTableObj.model';
import { TranslateService } from '@ngx-translate/core';
import { DatePickerComponent } from '../date-picker/date-picker.component';

@Component({
	selector: 'app-borrowers-details',
	templateUrl: './borrowers-details.component.html',
	styleUrls: ['./borrowers-details.component.scss']
})
export class BorrowersDetailsComponent implements OnInit, AfterViewInit, AfterViewChecked {
	qID: any;
	selectedOption: any;
	prevQID: any;
	borrowsNumber: number = 1;
	//question 1
	//mainBorrower: Borrower;
	mainBorrower: any;
	//question 7
	options;
	status;
	selectedOptionQ7;
	//question 20
	mainBorrowOtherIncome = [];
	//question 23
	childrenNumber: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'];
	maritalStatus: string[] = ["רווק", "נשוי", "גרוש", "אלמן"];
	placeResidence: string[] = ["אצל ההורים", "בשכירות", "במגורים ללא עלות חודשית", "בנכס בבעלותי שאין בכוונתי למכור", "בנכס בבעלותי שבכוונתי למכור"];
	typeCmbo;
	//question 33
	educationObjects: SysTableObj[];
	educationCombo: string[];
	//question 35
	selectedOptionQ35;
	visibleQids;
	editQuestion;
	currentStep;
	borrowerDetails: FormGroup;
	submitted = false;
	userDetails;
	borrowers;
	submitQID
	isMobilePhone: boolean;
	defaultValue = "";
	console = console;
	window = window;
	minBirthDate = { year: (new Date().getFullYear()) - 100, month: 1, day: 1 }; //from -100 years
	maxBirthDate = { year: (new Date().getFullYear()) - 15, month: 12, day: 31 };  //to 15 years old
	minWorkDate = { year: (new Date().getFullYear()) - 50, month: 1, day: 1 };  //from -50 years
	maxWorkDate = /*this.setTomorrowDate();*/{ year: new Date().getFullYear(), month: (new Date().getMonth() + 1), day: new Date().getDate() };//till now	
	startDate = { year: 2018, month: 5, day: 2 }
	isEdit;
	//Q11
	companyClassificationList: string[];
	companyClassificationObjects: SysTableObj[];
	statusTable;

	//get prefessions from local json 
	public professionsList;
	profession: FormControl;

	qFields = {
		/* main borrower */
		1: [
			// { name: "address", validators: [Validators.required, Validators.pattern("^[0-9A-Za-zא-ת\ \.]*$")] },
			// { name: "birthDate", validators: [Validators.required, ValidateDate], type:"Date" },
			{ name: "childrenNumber", validators: [Validators.required] },
			// { name: "maritalStatus", validators: [Validators.required] },
			{ name: "placeResidence", validators: [Validators.required] } //,
			// { name: "email", validators: [Validators.required, this.checkEmail(), Validators.pattern("^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,5})$")] }
		],
		"4.1": [{ name: "payMezonot", validators: [] }],
		5: [
			{ name: "education", validators: [Validators.required], systemTable: "stringTable", numberSystemTable: ["1453", "1499"] },
			{ name: "profession", validators: [Validators.required, Validators.pattern('^[A-Za-zא-ת\ \"\(\)\/]*$')] }
			// { name: "profession", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }
		],
		7: [{ name: "employmentStatus", validators: [] }],
		'8a': [{ name: "startOfWorkDateWithEmployer-a", validators: [] }],
		'8b': [{ name: "startOfWorkDateWithEmployer-b", validators: [] }],
		'9a': [{ name: "howLongWorkedPreviousWorkplace-a", validators: [Validators.required, ValidateNegativeNumber] }],
		'9b': [{ name: "howLongWorkedPreviousWorkplace-b", validators: [Validators.required, ValidateNegativeNumber] }],
		10: [{ name: "monthlyIncome", validators: [Validators.required] }],
		11: [
			{ name: "employersCompanyName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "employersCompanyField", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "employersCompanyClassification", validators: [Validators.required] }
		],
		13: [{ name: "annualIncome", validators: [Validators.required] }],
		14: [{ name: "startOfWorkDateAsEmployee", validators: [Validators.required, ValidateDate], type: "Date" },
		{ name: "monthlyIncomeAsEmployee", validators: [Validators.required] }],
		16: [
			{ name: "companyNameForEmployee", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "companyFieldForEmployee", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "companyClassificationForEmployee", validators: [Validators.required] }
		],
		18: [{ name: "startOfWorkDateAsEmployee1", validators: [Validators.required, ValidateDate], type: "Date" },
		{ name: "annualIncome-b", validators: [Validators.required, Validators.min(1)] }],
		20: [{
			name: "otherIncome", validators: [], type: "OtherIncome", systemTable: "arrayTable",
			qNamesSystemTable: [[["type"], ["type"]]], numberSystemTable: [[["1705"], ["1705"]]]
		}],
		'20.1': [{ name: "seniority", validators: [] }],
		29: [{
			name: "borrowersAdvancedArray", type: "borrowersAdvancedArray", systemTable: "arrayTable",
			qNamesSystemTable: [[["borrowerMaritalStatus"], ["borrowerMaritalStatus"], ["borrowerMaritalStatus"], ["borrowerMaritalStatus"], ["borrowerMaritalStatus"]]],
			numberSystemTable: [[["1719"], ["1719"], ["1719"], ["1719"], ["1719"]]]
		}],

		/* borrower 1 */
		"33-1": [
			{ name: "brwEducation-1", validators: [Validators.required], systemTable: "stringTable", numberSystemTable: ["1453", "1499"] },
			{ name: "brwProfession-1", validators: [Validators.required, Validators.pattern('^[A-Za-zא-ת\ \"\(\)\/]*$')] }
		],
		"35-1": [{ name: "brwEmploymentStatus-1", validators: [] }],
		'36a-1': [{ name: "brwStartOfWorkDateWithEmployer-a-1", validators: [] }],
		'36b-1': [{ name: "brwStartOfWorkDateWithEmployer-b-1", validators: [] }],
		'37a-1': [{ name: "brwHowLongWorkedPreviousWorkplace-a-1", validators: [Validators.required, ValidateNegativeNumber] }],
		'37b-1': [{ name: "brwHowLongWorkedPreviousWorkplace-b-1", validators: [Validators.required, ValidateNegativeNumber] }],
		'38-1': [{ name: "brwMonthlyIncome-1", validators: [Validators.required, Validators.min(1)] }],
		'39-1': [
			{ name: "brwEmployersCompanyName-1", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "brwEmployersCompanyField-1", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "brwEmployersCompanyClassification-1", validators: [Validators.required] }
		],
		'41-1': [{ name: "brwAnnualIncome-a-1", validators: [Validators.required, Validators.min(1)] }],
		'42-1': [
			{ name: "brwStartOfWorkDateAsEmployee-1", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "brwMonthlyIncomeAsEmployee-1", validators: [Validators.required, Validators.min(1)] }
		],
		'44-1': [
			{ name: "brwCompanyNameForEmployee-1", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "brwCompanyFieldForEmployee-1", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "brwCompanyClassificationForEmployee-1", validators: [Validators.required] }
		],
		'46-1': [
			{ name: "brwStartOfWorkDateAsEmployee1-1", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "brwAnnualIncome-b-1", validators: [Validators.required, Validators.min(1)] }
		],
		'48-1': [{
			name: "brwOtherIncome-1", validators: [], type: "OtherIncome", systemTable: "arrayTable",
			qNamesSystemTable: [[["type"], ["type"]]], numberSystemTable: [[["1705"], ["1705"]]]
		}],

		/* borrower 2 */
		"33-2": [
			{ name: "brwEducation-2", validators: [Validators.required], systemTable: "stringTable", numberSystemTable: ["1453", "1499"] },
			{ name: "brwProfession-2", validators: [Validators.required, Validators.pattern('^[A-Za-zא-ת\ \"\(\)\/]*$')] }
		],
		"35-2": [{ name: "brwEmploymentStatus-2", validators: [] }],
		'36a-2': [{ name: "brwStartOfWorkDateWithEmployer-a-2", validators: [] }],
		'36b-2': [{ name: "brwStartOfWorkDateWithEmployer-b-2", validators: [] }],
		'37a-2': [{ name: "brwHowLongWorkedPreviousWorkplace-a-2", validators: [Validators.required, ValidateNegativeNumber] }],
		'37b-2': [{ name: "brwHowLongWorkedPreviousWorkplace-b-2", validators: [Validators.required, ValidateNegativeNumber] }],
		'38-2': [{ name: "brwMonthlyIncome-2", validators: [Validators.required, Validators.min(1)] }],
		'39-2': [
			{ name: "brwEmployersCompanyName-2", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "brwEmployersCompanyField-2", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "brwEmployersCompanyClassification-2", validators: [Validators.required] }
		],
		'41-2': [{ name: "brwAnnualIncome-a-2", validators: [Validators.required, Validators.min(1)] }],
		'42-2': [
			{ name: "brwStartOfWorkDateAsEmployee-2", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "brwMonthlyIncomeAsEmployee-2", validators: [Validators.required, Validators.min(1)] }
		],
		'44-2': [
			{ name: "brwCompanyNameForEmployee-2", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "brwCompanyFieldForEmployee-2", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "brwCompanyClassificationForEmployee-2", validators: [Validators.required] }
		],
		'46-2': [
			{ name: "brwStartOfWorkDateAsEmployee1-2", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "brwAnnualIncome-b-2", validators: [Validators.required, Validators.min(1)] }
		],
		'48-2': [{
			name: "brwOtherIncome-2", validators: [], type: "OtherIncome", systemTable: "arrayTable",
			qNamesSystemTable: [[["type"], ["type"]]], numberSystemTable: [[["1705"], ["1705"]]]
		}],

		/* borrower 3 */
		"33-3": [
			{ name: "brwEducation-3", validators: [Validators.required], systemTable: "stringTable", numberSystemTable: ["1453", "1499"] },
			{ name: "brwProfession-3", validators: [Validators.required, Validators.pattern('^[A-Za-zא-ת\ \"\(\)\/]*$')] }
		],
		"35-3": [{ name: "brwEmploymentStatus-3", validators: [] }],
		'36a-3': [{ name: "brwStartOfWorkDateWithEmployer-a-3", validators: [] }],
		'36b-3': [{ name: "brwStartOfWorkDateWithEmployer-b-3", validators: [] }],
		'37a-3': [{ name: "brwHowLongWorkedPreviousWorkplace-a-3", validators: [Validators.required, ValidateNegativeNumber] }],
		'37b-3': [{ name: "brwHowLongWorkedPreviousWorkplace-b-3", validators: [Validators.required, ValidateNegativeNumber] }],
		'38-3': [{ name: "brwMonthlyIncome-3", validators: [Validators.required, Validators.min(1)] }],
		'39-3': [
			{ name: "brwEmployersCompanyName-3", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "brwEmployersCompanyField-3", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "brwEmployersCompanyClassification-3", validators: [Validators.required] }
		],
		'41-3': [{ name: "brwAnnualIncome-a-3", validators: [Validators.required, Validators.min(1)] }],
		'42-3': [
			{ name: "brwStartOfWorkDateAsEmployee-3", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "brwMonthlyIncomeAsEmployee-3", validators: [Validators.required, Validators.min(1)] }
		],
		'44-3': [
			{ name: "brwCompanyNameForEmployee-3", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "brwCompanyFieldForEmployee-3", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "brwCompanyClassificationForEmployee-3", validators: [Validators.required] }
		],
		'46-3': [
			{ name: "brwStartOfWorkDateAsEmployee1-3", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "brwAnnualIncome-b-3", validators: [Validators.required, Validators.min(1)] }
		],
		'48-3': [{
			name: "brwOtherIncome-3", validators: [], type: "OtherIncome", systemTable: "arrayTable",
			qNamesSystemTable: [[["type"], ["type"]]], numberSystemTable: [[["1705"], ["1705"]]]
		}],

		/* borrower 4 */
		"33-4": [
			{ name: "brwEducation-4", validators: [Validators.required], systemTable: "stringTable", numberSystemTable: ["1453", "1499"] },
			{ name: "brwProfession-4", validators: [Validators.required, Validators.pattern('^[A-Za-zא-ת\ \"\(\)\/]*$')] }
		],
		"35-4": [{ name: "brwEmploymentStatus-4", validators: [] }],
		'36a-4': [{ name: "brwStartOfWorkDateWithEmployer-a-4", validators: [] }],
		'36b-4': [{ name: "brwStartOfWorkDateWithEmployer-b-4", validators: [] }],
		'37a-4': [{ name: "brwHowLongWorkedPreviousWorkplace-a-4", validators: [Validators.required, ValidateNegativeNumber] }],
		'37b-4': [{ name: "brwHowLongWorkedPreviousWorkplace-b-4", validators: [Validators.required, ValidateNegativeNumber] }],
		'38-4': [{ name: "brwMonthlyIncome-4", validators: [Validators.required, Validators.min(1)] }],
		'39-4': [
			{ name: "brwEmployersCompanyName-4", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "brwEmployersCompanyField-4", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "brwEmployersCompanyClassification-4", validators: [Validators.required] }
		],
		'41-4': [{ name: "brwAnnualIncome-a-4", validators: [Validators.required, Validators.min(1)] }],
		'42-4': [
			{ name: "brwStartOfWorkDateAsEmployee-4", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "brwMonthlyIncomeAsEmployee-4", validators: [Validators.required, Validators.min(1)] }
		],
		'44-4': [
			{ name: "brwCompanyNameForEmployee-4", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "brwCompanyFieldForEmployee-4", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "brwCompanyClassificationForEmployee-4", validators: [Validators.required] }
		],
		'46-4': [
			{ name: "brwStartOfWorkDateAsEmployee1-4", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "brwAnnualIncome-b-4", validators: [Validators.required, Validators.min(1)] }
		],
		'48-4': [{
			name: "brwOtherIncome-4", validators: [], type: "OtherIncome", systemTable: "arrayTable",
			qNamesSystemTable: [[["type"], ["type"]]], numberSystemTable: [[["1705"], ["1705"]]]
		}],

		/* borrower 5 */
		"33-5": [
			{ name: "brwEducation-5", validators: [Validators.required], systemTable: "stringTable", numberSystemTable: ["1453", "1499"] },
			{ name: "brwProfession-5", validators: [Validators.required, Validators.pattern('^[A-Za-zא-ת\ \"\(\)\/]*$')] }
		],
		"35-5": [{ name: "brwEmploymentStatus-5", validators: [] }],
		'36a-5': [{ name: "brwStartOfWorkDateWithEmployer-a-5", validators: [] }],
		'36b-5': [{ name: "brwStartOfWorkDateWithEmployer-b-5", validators: [] }],
		'37a-5': [{ name: "brwHowLongWorkedPreviousWorkplace-a-5", validators: [Validators.required, ValidateNegativeNumber] }],
		'37b-5': [{ name: "brwHowLongWorkedPreviousWorkplace-b-5", validators: [Validators.required, ValidateNegativeNumber] }],
		'38-5': [{ name: "brwMonthlyIncome-5", validators: [Validators.required, Validators.min(1)] }],
		'39-5': [
			{ name: "brwEmployersCompanyName-5", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "brwEmployersCompanyField-5", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "brwEmployersCompanyClassification-5", validators: [Validators.required] }
		],
		'41-5': [{ name: "brwAnnualIncome-a-5", validators: [Validators.required, Validators.min(1)] }],
		'42-5': [
			{ name: "brwStartOfWorkDateAsEmployee-5", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "brwMonthlyIncomeAsEmployee-5", validators: [Validators.required, Validators.min(1)] }
		],
		'44-5': [
			{ name: "brwCompanyNameForEmployee-5", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")], systemTable: "stringTable", numberSystemTable: ["", "1443"] },
			// { name: "brwCompanyFieldForEmployee-5", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "brwCompanyClassificationForEmployee-5", validators: [Validators.required] }
		],
		'46-5': [
			{ name: "brwStartOfWorkDateAsEmployee1-5", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "brwAnnualIncome-b-5", validators: [Validators.required, Validators.min(1)] }
		],
		'48-5': [{
			name: "brwOtherIncome-5", validators: [], type: "OtherIncome", systemTable: "arrayTable",
			qNamesSystemTable: [[["type"], ["type"]]], numberSystemTable: [[["1705"], ["1705"]]]
		}]
	};

	qArrFields = {
		20: [
			{ name: "type", validators: [Validators.required] },
			{ name: "amount", validators: [Validators.required, Validators.min(1)] },
			{ name: "source", validators: [Validators.min(1)] }
		],
		23: [
			{ name: "borrowerFullName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ \.]*$")] },
			{ name: "borrowerPhoneNumber", validators: [Validators.required, this.validatePhone(), Validators.pattern("^[0-9]*$")] },
			{ name: "borrowerBirthDate", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "borrowerIdNumber", validators: [Validators.required, ValidateId] },
			{ name: "borrowerProximity", validators: [Validators.required] },
			{ name: "borrowerId", validators: [] }

		],
		29: [
			{ name: "borrowerFullName", validators: [] },
			// { name: "borrowerAddress", validators: [Validators.required, Validators.pattern("^[0-9A-Za-zא-ת\ \.]*$")] },
			{ name: "borrowerChildrenNumber", validators: [Validators.required] },
			{ name: "borrowerMaritalStatus", validators: [Validators.required] }
		],
		'48-1': [
			{ name: "type", validators: [Validators.required] },
			{ name: "amount", validators: [Validators.required, Validators.min(1)] },
			{ name: "source", validators: [Validators.min(1)] }
		],
		'48-2': [
			{ name: "type", validators: [Validators.required] },
			{ name: "amount", validators: [Validators.required] },
			{ name: "source", validators: [Validators.min(1)] }
		],
		'48-3': [
			{ name: "type", validators: [Validators.required] },
			{ name: "amount", validators: [Validators.required, Validators.min(1)] },
			{ name: "source", validators: [Validators.min(1)] }
		],
		'48-4': [
			{ name: "type", validators: [Validators.required] },
			{ name: "amount", validators: [Validators.required] }
		],
		'48-5': [
			{ name: "type", validators: [Validators.required] },
			{ name: "amount", validators: [Validators.required, Validators.min(1)] },
			{ name: "source", validators: [Validators.min(1)] }
		],

	};
	otherIncomeObjects: SysTableObj[];

	@ViewChild('startOfWorkDateAsEmployee') startOfWorkDateAsEmployee: DatePickerComponent;
	@ViewChild('minWorkDate') minWorkDateComponent: DatePickerComponent;

	private setTomorrowDate() {
		const date = new Date();
		date.setDate(date.getDate() + 1);
		return { year: date.getFullYear(), month: (date.getMonth() + 1), day: date.getDate() }
	}

	constructor(
		private route: ActivatedRoute,
		private questionnaireService: QuestionnaireService,
		private fb: FormBuilder,
		private draft: Draft,
		private systemTablesService: SystemTablesService,
		private _changeDetector: ChangeDetectorRef,
		private translate: TranslateService
	) { }

	ngOnInit() {
		this.currentStep = this.questionnaireService.getStep("borrowers-details");
		this.userDetails = this.questionnaireService.getStep("user-details");
		this.profession = new FormControl(this.questionnaireService.getQuestion(this.currentStep, "5").answer.fields[1].answerValue);
		this.status = this.questionnaireService.getQuestion(this.userDetails, "5").answer.fields[0].answerValue;
		this.getSysTables();

		//this.currentStep = this.questionnaireService.getStep("borrowers-details");
		this.borrowers = this.questionnaireService.getBorrowers();
		this.createForm();
		this.updateFormWithControls();
		//this.getSystemTbl(); //get prefessions from system table
		this.route.params.subscribe(params => {
			this.prevQID = this.qID;
			this.qID = params['qid'];
			this.editQuestion = null;

			if (this.qID === '29') {
				this.borrowers = this.questionnaireService.getBorrowers();
				this.rebuildForm();
				//this.createForm();
				this.updateFormWithControls();
			}

			if (params.qid === "all") {
				this.isEdit = true;
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				this.borrowers = this.questionnaireService.getBorrowers();
				// this.rebuildForm();
				// this.updateFormWithControls();
			} else {
				this.isEdit = false;
				this.setValidators();
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				if (this.qID !== '1') {
					this.setFocusFirstComponent(this.qID)
					// console.log('setFocusFirstComponent from router...')
				}
			}
		});

		this.options = [
			{ label: 'BORROWERS_DETAILS.QUESTION7.A1', id: "employee", class: "employee" },
			{ label: 'BORROWERS_DETAILS.QUESTION7.A2', id: "independent", class: "independent" },
			{ label: 'BORROWERS_DETAILS.QUESTION7.A3', id: "unemployed", class: "unemployed" },
			{ label: 'BORROWERS_DETAILS.QUESTION7.A4', id: "employeeAndIndependent", class: "employee-independent" }
		];

		this.selectedOptionQ7 = "3";
		this.selectedOptionQ35 = "2";

		if (this.draft.autoForm) {
			this.borrowerDetails = this.draft.buildForm(this.currentStep, this.borrowerDetails);
		}
	}

	private setFocusFirstComponent(qID) {
		if (this.qID === '1') {
			this.focusToElement(`div[aria-label="${this.translate.instant('BORROWERS_DETAILS.QUESTION1.CHILDREN_NUMBER')}"]`);
		} else if (this.qID === '5') {
			this.focusToElement(`div[aria-label="${this.translate.instant('COMMON.SELECT_EDUCATION_PH')}"]`);
		} else if (this.qID === '7') {
			// this.focusToElement(`div[aria-label="${this.translate.instant('COMMON.SELECT_EDUCATION_PH')}"]`);
		} else if (this.qID === '8a') {
			this.focusToElement(`label[data-id="qID8aa"`);
		} else if (this.qID === '8b') {
			this.focusToElement(`label[data-id="qID8ba"`);
		} else if (this.qID === '9a') {
			this.focusToElement(`input[aria-label="${this.translate.instant('BORROWERS_DETAILS.QUESTION9.QUESTIONa')}"]`);
		} else if (this.qID === '9b') {
			this.focusToElement(`input[aria-label="${this.translate.instant('BORROWERS_DETAILS.QUESTION9.QUESTIONb')}"]`);
		} else if (this.qID === '10') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('BORROWERS_DETAILS.QUESTION10.QUESTION')}"]`);
		} else if (this.qID === '11') {
			this.focusToElement(`input[aria-label="${this.translate.instant('BORROWERS_DETAILS.QUESTION11.PH1')}"]`);
		} else if (this.qID === '13') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('BORROWERS_DETAILS.QUESTION13.QUESTION')}"]`);
		} else if (this.qID === '14') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('BORROWERS_DETAILS.QUESTION14.QUESTION1')}"]`);
			if (this.startOfWorkDateAsEmployee) {
				this.startOfWorkDateAsEmployee.toggleD2();
			}
		} else if (this.qID === '16') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('BORROWERS_DETAILS.QUESTION16.PH1')}"]`, 1);
		} else if (this.qID === '18') {
			// this.focusToElement(`input[data-date-id="'d18'"]`);
			// if (this.minWorkDateComponent) {
			// 	this.minWorkDateComponent.toggleD2();
			// }
		} else if (this.qID === '20') {
			// this.focusToElement(`div[aria-label="${this.translate.instant('COMMON.SELECT_EDUCATION_PH')}"]`);
		}

	}

	getSysTables() {
		this.otherIncomeObjects = this.systemTablesService.getTable('1705', false);
		this.typeCmbo = this.otherIncomeObjects.map(v => v.name);

		this.statusTable = this.systemTablesService.getTable('1719');

		this.professionsList = this.systemTablesService.getTable('1499');

		this.educationObjects = this.systemTablesService.getTable('1453', false);
		this.educationCombo = this.educationObjects.map(v => v.name);

		this.companyClassificationObjects = this.systemTablesService.getTable('1443');
		this.companyClassificationList = this.companyClassificationObjects.map(v => v.name);
	}

	// rebuildFormFor23() {
	// 	this.borrowerDetails.setControl('borrowersArray',BorrowersArrayComponent.builBorrowers(this.questionnaireService.getQuestion(this.currentStep, "23").answer['answer-data']));
	// }

	rebuildForm() {
		this.borrowerDetails.setControl('borrowersAdvancedArray', BorrowersArrayComponent.builAdvancedBorrowers(this.borrowers, this.questionnaireService.getQuestion(this.currentStep, "29").answer['answer-data'], this.questionnaireService.getQuestion(this.currentStep, "1"), this.questionnaireService.getQuestion(this.userDetails, "5")));
	}

	ifHasIncome(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } => {
			let moreBorrowers = control.value;
			let otherIncome = this.questionnaireService.getQuestion(this.currentStep, "20").answer.fieldsArray;
			if (moreBorrowers === 'NO') {
				if (otherIncome.length == 1 && (otherIncome[0][1].answerValue == 0 || otherIncome[0][1].answerValue === "")) {
					return { noIncome: true }
				}
			}
			return null;
		}
	}

	validatePhone(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } => {
			if (this.isMobilePhone && control.value && control.value.length < 10) {//isMobilePhone not work
				return {
					minlength: true
				};
			} else if (!this.isMobilePhone && control.value && control.value.length < 9) {//isMobilePhone not work
				return {
					minlength: true
				};
			}
		};
	}

	//add borrowers form controls
	updateFormWithControls() {
		let getQuestion = this.questionnaireService.getQuestion;

		for (let i = 0; i < this.borrowers.length; i++) {
			this.borrowerDetails.addControl('brwEducation-' + (i + 1), new FormControl(getQuestion(this.currentStep, "33-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwProfession-' + (i + 1), new FormControl(getQuestion(this.currentStep, "33-" + (i + 1)).answer.fields[1].answerValue));
			this.borrowerDetails.addControl('brwEmploymentStatus-' + (i + 1), new FormControl(getQuestion(this.currentStep, "35-" + (i + 1)).selectedAnswer[0]));
			this.borrowerDetails.addControl('brwStartOfWorkDateWithEmployer-a-' + (i + 1), new FormControl(getQuestion(this.currentStep, "36a-" + (i + 1)).selectedAnswer[0]));
			this.borrowerDetails.addControl('brwStartOfWorkDateWithEmployer-b-' + (i + 1), new FormControl(getQuestion(this.currentStep, "36b-" + (i + 1)).selectedAnswer[0]));
			this.borrowerDetails.addControl('brwHowLongWorkedPreviousWorkplace-a-' + (i + 1), new FormControl(getQuestion(this.currentStep, "37a-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwHowLongWorkedPreviousWorkplace-b-' + (i + 1), new FormControl(getQuestion(this.currentStep, "37b-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwMonthlyIncome-' + (i + 1), new FormControl(getQuestion(this.currentStep, "38-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwEmployersCompanyName-' + (i + 1), new FormControl(getQuestion(this.currentStep, "39-" + (i + 1)).answer.fields[0].answerValue));
			// this.borrowerDetails.addControl('brwEmployersCompanyField-' + (i + 1), new FormControl(getQuestion(this.currentStep, "39-" + (i + 1)).answer.fields[1].answerValue));
			this.borrowerDetails.addControl('brwEmployersCompanyClassification-' + (i + 1), new FormControl(getQuestion(this.currentStep, "39-" + (i + 1)).answer.fields[1].answerValue));
			this.borrowerDetails.addControl('brwAnnualIncome-a-' + (i + 1), new FormControl(getQuestion(this.currentStep, "41-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwAnnualIncome-b-' + (i + 1), new FormControl(getQuestion(this.currentStep, "41-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwStartOfWorkDateAsEmployee-' + (i + 1), new FormControl(getQuestion(this.currentStep, "42-" + (i + 1)).answer.fields[1].answerValue));
			this.borrowerDetails.addControl('brwMonthlyIncomeAsEmployee-' + (i + 1), new FormControl(getQuestion(this.currentStep, "42-" + (i + 1)).answer.fields[1].answerValue));
			this.borrowerDetails.addControl('brwCompanyNameForEmployee-' + (i + 1), new FormControl(getQuestion(this.currentStep, "44-" + (i + 1)).answer.fields[0].answerValue));
			// this.borrowerDetails.addControl('brwCompanyFieldForEmployee-' + (i + 1), new FormControl(getQuestion(this.currentStep, "44-" + (i + 1)).answer.fields[1].answerValue));
			this.borrowerDetails.addControl('brwCompanyClassificationForEmployee-' + (i + 1), new FormControl(getQuestion(this.currentStep, "44-" + (i + 1)).answer.fields[1].answerValue));
			this.borrowerDetails.addControl('brwStartOfWorkDateAsEmployee1-' + (i + 1), new FormControl(getQuestion(this.currentStep, "46-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwCompanyFieldEmployee-' + (i + 1), new FormControl(getQuestion(this.currentStep, "46-" + (i + 1)).answer.fields[1].answerValue));
			this.borrowerDetails.addControl('brwOtherIncome-' + (i + 1), IncomesArrayComponent.buildIncomes(getQuestion(this.currentStep, "48-" + (i + 1)).answer.fieldsArray));
		}
	}

	createForm() {
		let startOfWorkDateAsEmployee;
		let startOfWorkDateAsEmployee1;
		if (typeof this.questionnaireService.getQuestion(this.currentStep, "14").answer.fields[0].answerValue === 'string') {
			startOfWorkDateAsEmployee = this.questionnaireService.customFormat(this.questionnaireService.getQuestion(this.currentStep, "14").answer.fields[0].answerValue)
		} else {
			this.questionnaireService.getQuestion(this.currentStep, "14").answer.fields[0].answerValue
		}
		if (typeof this.questionnaireService.getQuestion(this.currentStep, "18").answer.fields[0].answerValue === 'string') {
			startOfWorkDateAsEmployee = this.questionnaireService.customFormat(this.questionnaireService.getQuestion(this.currentStep, "18").answer.fields[0].answerValue)
		} else {
			this.questionnaireService.getQuestion(this.currentStep, "18").answer.fields[0].answerValue
		}

		this.borrowerDetails = this.fb.group({ // <-- the parent FormGroup
			// 'address': this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue,
			// 'birthDate': this.questionnaireService.customFormat(this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[1].answerValue),			
			'childrenNumber': this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue,
			// 'maritalStatus': this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[3].answerValue,		
			// 'email': this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[2].answerValue,
			// 'email': this.userDetails.questions.find(el => el.questionId === '4.5').answer.fields[0].answerValue,
			'placeResidence': this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[1].answerValue,
			'payMezonot': this.questionnaireService.getQuestion(this.currentStep, "4.1").selectedAnswer,
			'education': this.questionnaireService.getQuestion(this.currentStep, "5").answer.fields[0].answerValue,
			'profession': this.profession,
			'employmentStatus': this.questionnaireService.getQuestion(this.currentStep, "7").selectedAnswer,
			'startOfWorkDateWithEmployer-a': this.questionnaireService.getQuestion(this.currentStep, "8a").selectedAnswer,
			'startOfWorkDateWithEmployer-b': this.questionnaireService.getQuestion(this.currentStep, "8b").selectedAnswer,
			'howLongWorkedPreviousWorkplace-a': this.questionnaireService.getQuestion(this.currentStep, "9a").answer.fields[0].answerValue,
			'howLongWorkedPreviousWorkplace-b': this.questionnaireService.getQuestion(this.currentStep, "9b").answer.fields[0].answerValue,
			'monthlyIncome': this.questionnaireService.getQuestion(this.currentStep, "10").answer.fields[0].answerValue,
			'employersCompanyName': this.questionnaireService.getQuestion(this.currentStep, "11").answer.fields[0].answerValue,
			// 'employersCompanyField': this.questionnaireService.getQuestion(this.currentStep, "11").answer.fields[1].answerValue,
			'employersCompanyClassification': this.questionnaireService.getQuestion(this.currentStep, "11").answer.fields[1].answerValue,
			'annualIncome': this.questionnaireService.getQuestion(this.currentStep, "13").answer.fields[0].answerValue,
			'annualIncome-b': this.questionnaireService.getQuestion(this.currentStep, "18").answer.fields[0].answerValue,
			'startOfWorkDateAsEmployee': startOfWorkDateAsEmployee,
			'monthlyIncomeAsEmployee': this.questionnaireService.getQuestion(this.currentStep, "14").answer.fields[1].answerValue,
			'companyNameForEmployee': this.questionnaireService.getQuestion(this.currentStep, "16").answer.fields[0].answerValue,
			// 'companyFieldForEmployee': this.questionnaireService.getQuestion(this.currentStep, "16").answer.fields[1].answerValue,
			'companyClassificationForEmployee': this.questionnaireService.getQuestion(this.currentStep, "16").answer.fields[1].answerValue,
			'startOfWorkDateAsEmployee1': startOfWorkDateAsEmployee1,
			'companyFieldEmployee': this.questionnaireService.getQuestion(this.currentStep, "18").answer.fields[1].answerValue,
			'otherIncome': IncomesArrayComponent.buildIncomes(this.questionnaireService.getQuestion(this.currentStep, "20").answer.fieldsArray),
			'seniority': this.questionnaireService.getQuestion(this.currentStep, "20.1").selectedAnswer,
			// 'areThereAdditionalBorrowers': this.questionnaireService.getQuestion(this.currentStep, "22").selectedAnswer,
			// 'borrowersArray': BorrowersArrayComponent.builBorrowers(this.questionnaireService.getQuestion(this.currentStep, "23").answer['answer-data']),
			'borrowersAdvancedArray': BorrowersArrayComponent.builAdvancedBorrowers(this.borrowers, this.questionnaireService.getQuestion(this.currentStep, "29").answer['answer-data'], this.questionnaireService.getQuestion(this.currentStep, "1"))
		});
	}

	setValidators() {
		this.questionnaireService.clearAllQuestionValidators(this.borrowerDetails.controls, this.qFields, this.qArrFields);
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.borrowerDetails.controls, this.qFields, "4", this.qArrFields, false);
		this.submitted = false;
	}


	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
		}
	}

	getqID(qid, index) {
		index = index + 1;
		let str = '';
		str = qid + '-' + index;
		return str;
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		const invalid = [];
		const controls = this.borrowerDetails.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		console.log(invalid);
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit(): valid=", valid, ", value=", value);
		value = this.borrowerDetails.getRawValue();
		this.submitted = true;
		if (!valid) {
			this.questionnaireService.submitForm(true);
		}
		else {
			this.questionnaireService.submitForm(false);
		}
		if (this.qID === 'all' || this.qID === '20') {
			const s = this.borrowerDetails.controls.otherIncome as FormArray;
			// if (s.controls[0].get('type').value === 'אחר' && s.controls[0].get('source').value === "") {
			// 	this.questionnaireService.showErrorMsg(true);
			// 	valid = false;
			// }
		} else if (this.qID === '48-1' || this.qID === '48-2' || this.qID === '48-3' || this.qID === '48-4' || this.qID === '48-5') {
			for (let i = 0; i < this.borrowers.length; i++) {
				const s = this.borrowerDetails.controls['brwOtherIncome-' + (i + 1)] as FormArray;
				// if (s.controls[0].get('type').value === 'אחר' && s.controls[0].get('source').value === "") {
				// 	this.questionnaireService.showErrorMsg(true);
				// 	valid = false;
				// }
			}
			// brwOtherIncome-2
		}
		if (valid) {
			let q;
			this.submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;

			q = this.qFields[this.submitQID];

			let values = q.map(r => {
				return value[r.name];
			});
			let valueTmp = JSON.parse(JSON.stringify(value));
			this.setClassificationCode(valueTmp);
			this.setEducationAndProfessionCode(valueTmp);
			this.setOtherIncomeCode(valueTmp);
			this.setBrwMaritalCode(valueTmp);

			this.draft.buildArrDraft(this.submitQID, this.qFields, valueTmp, this.currentStep, this.isEdit);

			this.questionnaireService.sendGA(this.currentStep, this.qID, values);
			this.nextClick(this.submitQID, values);
		} else {
			window["logInvalidControls"](this.borrowerDetails);
		}
	}

	private setBrwMaritalCode(value) {
		if (this.submitQID === '29') {
			value.borrowersAdvancedArray.forEach((element) => {
				let statusCode = this.statusTable.find(v => v.name === element.borrowerMaritalStatus).code;
				element.borrowerMaritalStatus = statusCode;
			});
		}
	}

	private setOtherIncomeCode(value) {
		let otherIncomeValue = "";

		switch (this.qID) {
			//main borrower
			case "20":
				otherIncomeValue = "otherIncome";
				break;

			//borrowers
			case "48-1":
			case "48-2":
			case "48-3":
			case "48-4":
			case "48-5":
				otherIncomeValue = "brwOtherIncome-" + this.qID.slice(-1);
				break;
		}

		if (otherIncomeValue !== "") {
			for (let i = 0; i < value[otherIncomeValue].length; i++) {
				let otherIncomeCode = this.otherIncomeObjects.find(v => v.name === value[otherIncomeValue][i].type);
				if (otherIncomeCode) {
					value[otherIncomeValue][i].type = otherIncomeCode.code;
				}
			}
		}
	}

	private setEducationAndProfessionCode(value) {
		let professionCurrentValue = "";
		let educationCurrentValue = "";

		switch (this.qID) {
			//main borrower
			case "5":
				educationCurrentValue = "education";
				professionCurrentValue = "profession";
				break;

			//borrowers
			case "33-1":
			case "33-2":
			case "33-3":
			case "33-4":
			case "33-5":
				educationCurrentValue = "brwEducation-" + this.qID.slice(-1);
				professionCurrentValue = "brwProfession-" + this.qID.slice(-1);
				break;
		}

		if (educationCurrentValue !== "" && professionCurrentValue !== "") {
			let educationCode = this.educationObjects.find(v => v.name === value[educationCurrentValue]).code;
			let professionCode = this.professionsList.find(v => v.name === value[professionCurrentValue]).code;

			value[educationCurrentValue] = educationCode;
			value[professionCurrentValue] = professionCode;
		}

	}

	private setClassificationCode(value) {
		let classificationCurrentValue = "";

		switch (this.qID) {
			//main borrower
			case "11":
				classificationCurrentValue = "employersCompanyClassification";
				break;

			case "16":
				classificationCurrentValue = "companyClassificationForEmployee";
				break;

			//borrowers
			case "39-1":
			case "39-2":
			case "39-3":
			case "39-4":
			case "39-5":
				classificationCurrentValue = "brwEmployersCompanyClassification-" + this.qID.slice(-1);
				break;

			case "44-1":
			case "44-2":
			case "44-3":
			case "44-4":
			case "44-5":
				classificationCurrentValue = "brwCompanyClassificationForEmployee-" + this.qID.slice(-1);
				break;
		}

		if (classificationCurrentValue !== "") {
			let classificationCode = this.companyClassificationObjects.find(v => v.name === value[classificationCurrentValue]).code;
			value[classificationCurrentValue] = classificationCode;
		}
	}

	editQuestionChange(qid) {
		this.qID = qid;
		this.setValidators();
	}

	ngAfterViewChecked(): void {
		if (!this._changeDetector['destroyed']) {
			this._changeDetector.detectChanges();
		}
	}

	ngAfterViewInit(): void {
		this.setFocusFirstComponent('1');
		// console.log('ngAfterViewChecked...');
	}

	focusNextElement() {
		const arrayElement = Array.from(document.querySelectorAll('[tabindex]'));
		const focussableIndex = arrayElement.indexOf(document.activeElement);
		if (focussableIndex > -1) {
			const nextElement = arrayElement[focussableIndex + 1] || arrayElement[0];
			(nextElement as HTMLElement).focus();
		}
	}

	focusToElement(selector: string, index: number = 0) {
		const selectedElement = Array.from(document.querySelectorAll(selector));

		if (selectedElement && selectedElement.length > 0) {
			const nowActiveElement = document.activeElement;
			(nowActiveElement as HTMLElement).blur();
			setTimeout(() => (selectedElement[index] as HTMLElement).focus(), 0);
		}
	}

	onDateUpdate(evt, target) {
		const translatedValue = this.translate.instant(`input[aria-label="${this.translate.instant(target)}"]`);
		this.focusToElement(translatedValue);
	}

	@HostListener('window:keydown', ['$event'])
	keyEvent(event: KeyboardEvent): any {
		if (event.key === 'Enter') {
			if ((event.target as HTMLElement).dataset.fieldname) {
				if ((event.target as HTMLElement).dataset.fieldname === 'startOfWorkDateWithEmployer-a' ||
					(event.target as HTMLElement).dataset.fieldname === 'startOfWorkDateWithEmployer-b' ||
					(event.target as HTMLElement).dataset.fieldname.indexOf('brwStartOfWorkDateWithEmployer-a-') > -1 ||
					(event.target as HTMLElement).dataset.fieldname.indexOf('brwStartOfWorkDateWithEmployer-b-') > -1 ||
					(event.target as HTMLElement).dataset.fieldname === 'payMezonot') {
					this.borrowerDetails.controls[(event.target as HTMLElement).dataset.fieldname].setValue((event.target as HTMLElement).dataset.fieldvalue);
					this.onSubmit(this.borrowerDetails);
				}
			}
		}

	}
}



// WEBPACK FOOTER //
// ./src/app/borrowers-details/borrowers-details.component.ts